import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TextComponent } from '@app/components/text/text.component';
import { RestaurantTableService } from '@core';

@Component({
  selector: 'app-header-badge-table-name',
  templateUrl: './header-badge-table-name.component.html',
  styleUrl: './header-badge-table-name.component.scss',
  imports: [
    TextComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderBadgeTableNameComponent {

  private readonly restaurantTableService = inject(RestaurantTableService);

  protected readonly name = toSignal(this.restaurantTableService.tableName$);

}
